import React, { Component } from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import { Provider } from 'react-redux';
import { createStore, compose, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import ReduxToastr from 'react-redux-toastr'

import history from './routes/history';
import Routes from './routes';
import createRootReducer from './reducers';
import ModalComponent from './components/ModalComponent';
import FullPageLoader from './components/FullPageLoader';
  
class App extends Component {

    componentWillMount() {
        // // Your web app's Firebase configuration
        // var firebaseConfig = {
        //     apiKey: "AIzaSyCkQ9ac-LbIMjYwGYM462geDwAXvHoi_EQ",
        //     authDomain: "vtcall-9292.firebaseapp.com",
        //     databaseURL: "https://vtcall-9292.firebaseio.com",
        //     projectId: "vtcall-9292",
        //     storageBucket: "vtcall-9292.appspot.com",
        //     messagingSenderId: "266863121525",
        //     appId: "1:266863121525:web:a6b127b373e07eaba1d43c",
        //     measurementId: "G-435G3MN31W"
        // };
        // // Initialize Firebase
        // firebase.initializeApp(firebaseConfig);

        // // Obtenha uma referência para os serviços de autenticação e banco de dados
        // let email = 'datascan.ti@gmail.com';
        // let senha = 'ma212254';

        // firebase.auth().signInWithEmailAndPassword(email, senha)
        // .then((userCredential) => {
        //     // Usuário validado com sucesso
        //     const user = userCredential.user;
        //     console.log("Usuário validado:", user.uid);
        // })
        // .catch((error) => {
        //     console.error("Erro ao validar usuário:", error.message);
        // });

    }

    render() {  
        return (
            <Provider store={ 
                createStore(
                    createRootReducer(history), 
                    {}, 
                    compose(
                        applyMiddleware(
                            routerMiddleware(history), // for dispatching history actions
                            ReduxThunk
                        ),
                    ),
            ) }>
                <Routes />
                <ModalComponent />
                <ReduxToastr
                    timeOut={4000}
                    newestOnTop={false}
                    preventDuplicates
                    position="bottom-right"
                    getState={(state) => state.toastr} // This is the default
                    transitionIn="bounceIn"
                    transitionOut="bounceOut"
                    progressBar
                    closeOnToastrClick/>
                <FullPageLoader />
            </Provider>
        );
    }
}

export default App;
// export default connect(null, { recarregaUsuario })(App);
